import { render } from "./PriceModifierModal.vue?vue&type=template&id=9af7b844&scoped=true"
import script from "./PriceModifierModal.vue?vue&type=script&lang=js"
export * from "./PriceModifierModal.vue?vue&type=script&lang=js"

import "./PriceModifierModal.vue?vue&type=style&index=0&id=9af7b844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af7b844"]])

export default __exports__